import { DialogRef } from '@angular/cdk/dialog';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';

export const PENCIL_BOTTOM_SHEET_INSTANT_CLASS = 'pencil-bottom-sheet--instant';

// Material 14 keeps the CDK overlay on a private `_ref`. dismiss() always animates;
// DialogRef.close() / addPanelClass are the only way to skip that.
export function overlayDialogRef(sheetRef?: MatBottomSheetRef): DialogRef | undefined {
  return sheetRef && (sheetRef as unknown as { _ref?: DialogRef })._ref;
}
